import { Button } from '../../../../common/components';
import React, { useState } from 'react';
import { FullRow } from '../../../layout/components';

import { ScreeningTravellerTitle } from '../ScreeningTravellerTitle/ScreeningTravellerTitle';

const ConditionList = ({ conditions }) => {
  if (!conditions) {
    return (
      <li>
        <span>No conditions declared</span>
      </li>
    );
  }

  return (
    <ul>
      {conditions.map((condition, i) => {
        return (
          <li key={i}>
            <span>{condition}</span>
          </li>
        );
      })}
    </ul>
  );
};

const ScreeningSummary = ({
  show,
  traveller,
  travellerIndex,
  isSubmitting,
  isScreeningActive,
  isScreening,
  onStartScreening,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  if (!show) {
    return null;
  }

  const handleStart = () => {
    setIsLoading(true);
    return Promise.resolve(onStartScreening()).then(() => {
      setIsLoading(false);
    });
  };

  return (
    <FullRow>
      {!isScreening && (
        <Button
          className="pull-right"
          bsStyle={'primary'}
          label={traveller.screening_id ? 'Edit Conditions' : 'Add conditions'}
          isLoading={isSubmitting && isLoading}
          disabled={isScreening && !isScreeningActive}
          handleClick={handleStart}
        />
      )}
      <ScreeningTravellerTitle traveller={traveller} travellerIndex={travellerIndex} />
      <ConditionList conditions={traveller?.screening?.meta?.conditions} />
    </FullRow>
  );
};

export default ScreeningSummary;
